import { useState, useEffect } from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';

export default function OurWork() {
  useEffect(() => {
    // Update meta tags based on embed_code
    document.title = 'Realizace koupelen a topení | Reference TopInstal Šnajdr';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Prohlédněte si naše realizace: rekonstrukce koupelen, montáže kotlů a opravy rozvodů vody v Mladé Boleslavi. Kvalitní řemeslná práce na fotkách.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'rekonstrukce koupelny fotogalerie, montáž kotle reference, instalatérské práce ukázky, výměna stoupaček');
    }
    
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/nase-prace`);
    }
    
    // Add Schema.org JSON-LD for ImageGallery
    const existingScript = document.querySelector('script[type="application/ld+json"][data-page="our-work"]');
    if (existingScript) {
      existingScript.remove();
    }
    
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-page', 'our-work');
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ImageGallery",
      "name": "Realizace koupelen a topení - TopInstal Šnajdr",
      "description": "Prohlédněte si naše realizace: rekonstrukce koupelen, montáže kotlů a opravy rozvodů vody v Mladé Boleslavi. Kvalitní řemeslná práce na fotkách.",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/nase-prace`,
      "provider": {
        "@type": "LocalBusiness",
        "name": "TopInstal Šnajdr",
        "telephone": "+420720520035",
        "email": "instatop.snajdr@post.cz",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Vinec 57",
          "addressLocality": "Mladá Boleslav",
          "postalCode": "293 01",
          "addressCountry": "CZ"
        }
      }
    });
    document.head.appendChild(script);
    
    return () => {
      const scriptToRemove = document.querySelector('script[type="application/ld+json"][data-page="our-work"]');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, []);

  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [activeCategory, setActiveCategory] = useState<string>('all');

  const categories = [
    { id: 'all', name: 'Vše', icon: 'ri-grid-line' },
    { id: 'heating', name: 'Topení', icon: 'ri-fire-line' },
    { id: 'plumbing', name: 'Vodoinstalace', icon: 'ri-drop-line' },
    { id: 'boilers', name: 'Kotle', icon: 'ri-settings-3-line' },
  ];

  const workImages: Array<{ src: string; alt: string; category: string }> = [
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/d32d3dbe81a4579639a7a4428afd14e9.jpeg',
      alt: 'Instalace podlahového topení s rozdělovačem',
      category: 'heating'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/f4789843adf37b0d184b783abcd00d59.jpeg',
      alt: 'Profesionální instalace topného systému',
      category: 'heating'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/21da0b3e6fbbebcbf74856a6c66396bf.jpeg',
      alt: 'Instalace podlahového vytápění',
      category: 'heating'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/877287463665d55c6289739fb3f8d8fe.jpeg',
      alt: 'Realizace topného systému',
      category: 'heating'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/1fc6faf1e4109b6e67e3a239e365f65c.jpeg',
      alt: 'Instalace podlahového vytápění v rodinném domě',
      category: 'heating'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/2dbf2f4975125b398950f4c041286def.jpeg',
      alt: 'Instalace topného systému v rodinném domě',
      category: 'heating'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/34f3fc480294be571c9706b150b95cb8.jpeg',
      alt: 'Profesionální instalace podlahového vytápění s rozdělovačem',
      category: 'heating'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/ac02e6ab5afa764579b8af85e2e9f281.jpeg',
      alt: 'Instalace podlahového vytápění s rozdělovačem a izolací',
      category: 'heating'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/c2e696c79f62af7cf24b2025d49c40ed.jpeg',
      alt: 'Instalace podlahového vytápění s precizním rozložením trubek',
      category: 'heating'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/e60b7de11f1bc42eaa2f30c05817947c.jpeg',
      alt: 'Instalace podlahového vytápění s detailním rozložením topných trubek',
      category: 'heating'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/de39803e534cb937f639923bb2fa353d.jpeg',
      alt: 'Instalace radiátoru v rodinném domě',
      category: 'heating'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/f6f9a2b76c9ef72f1f0b456f7db6517e.jpeg',
      alt: 'Instalace radiátoru pod střešním oknem',
      category: 'heating'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/95f1101909af3352dd6c36f6c74aaf86.jpeg',
      alt: 'Instalace podlahového vytápění s detailním rozložením topných trubek na izolační podložce',
      category: 'heating'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/8012660707474c8916b195e5fb59d07c.jpeg',
      alt: 'Instalace radiátoru v moderním interiéru',
      category: 'heating'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/dc1c9deeaaf05af3045dd9c33ac6b709.jpeg',
      alt: 'Instalace podlahového vytápění s červenými topnými trubkami na izolační podložce',
      category: 'heating'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/9883fb2de6c8e1cd34a5a019b42b9841.jpeg',
      alt: 'Instalace podlahového vytápění s červenými topnými trubkami v rozestavěném interiéru',
      category: 'heating'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/50bdf0f9cb814bf14deaf0e3314270d6.jpeg',
      alt: 'Instalace podlahového vytápění s červenými topnými trubkami v rekonstruované místnosti',
      category: 'heating'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/eba3999da910dec0e5ce6d2ef47d91ce.jpeg',
      alt: 'Instalace podlahového vytápění s rozdělovačem a červenými topnými trubkami v rodinném domě',
      category: 'heating'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/4dc7e9dcb39381e8be205d6a11859ea1.jpeg',
      alt: 'Instalace podlahového vytápění s precizním rozložením topných trubek v rodinném domě',
      category: 'heating'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/2775342d9d1d2aee30ba7d59e355739e.jpeg',
      alt: 'Instalace radiátoru pod střešním oknem v podkrovní místnosti',
      category: 'heating'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/c9c79294022de6db3f91e8baa182f22f.jpeg',
      alt: 'Instalace vodovodního potrubí',
      category: 'plumbing'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/ffac4a5ecacc37a0893cbe66ea6f4cd1.jpeg',
      alt: 'Instalace WC s obkladem',
      category: 'plumbing'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/dc26816c72e701b8d5273fa624f4c020.jpeg',
      alt: 'Instalace vodovodního systému',
      category: 'plumbing'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/a9107f0f8abad6948b4a86531dcee65e.jpeg',
      alt: 'Instalace vodovodního potrubí s uzavíracími ventily',
      category: 'plumbing'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/ac395776796789c8291de6ef8f7cfb3a.jpeg',
      alt: 'Instalace vodovodního systému s rozdělovačem',
      category: 'plumbing'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/ec8094513d21473410165bd50fb850fe.jpeg',
      alt: 'Instalace vodovodního systému s vodoměry a uzavíracími ventily',
      category: 'plumbing'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/a023497d89a6eebd2648ae4078202a65.jpeg',
      alt: 'Instalace vodovodního systému s filtrem a rozdělovačem',
      category: 'plumbing'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/96e7b1424296dd0f7f4754ba75b90c15.jpeg',
      alt: 'Instalace vodovodního a topného systému v rozestavěné koupelně',
      category: 'plumbing'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/f7f7ac9e87da06d9c2fdc010eef2926a.jpeg',
      alt: 'Moderní koupelna s osvětleným zrcadlem a podomítkovým WC',
      category: 'plumbing'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/52a596c6e56a0c99fc5b75b991022ab6.jpeg',
      alt: 'Instalace podomítkového WC systému Geberit s odpadním potrubím',
      category: 'plumbing'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/d55205a257c6f970b2af9a7448dd340a.jpeg',
      alt: 'Instalace vodovodního a topného systému v rozestavěné místnosti',
      category: 'plumbing'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/05a4c7cfe8ac1ffb108944f773043fa7.jpeg',
      alt: 'Instalace moderního plynového kotle s expanzní nádobou',
      category: 'boilers'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/2f3fff6a021a16e55859bce386bfbb67.jpeg',
      alt: 'Instalace plynového kotle s bojlerem a topným systémem v technické místnosti',
      category: 'boilers'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/fe790ceec7d0517ef23661056385b5f8.jpeg',
      alt: 'Instalace kotle OPOP Biopel MINI v technické místnosti s topným systémem',
      category: 'boilers'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/c55c844619e75e15e9b94e61f634c7b2.jpeg',
      alt: 'Instalace kotle Mocek s topným systémem a zásobníkem v technické místnosti',
      category: 'boilers'
    },
    {
      src: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/4eebd519c08239878fdada45c2e0072f.jpeg',
      alt: 'Instalace moderního plynového kotle s bojlerem a topným systémem v technické místnosti',
      category: 'boilers'
    }
  ];

  const filteredImages = activeCategory === 'all' 
    ? workImages 
    : workImages.filter(img => img.category === activeCategory);

  const stats = [
    { number: '100+', label: 'Realizovaných projektů', icon: 'ri-checkbox-circle-line' },
    { number: '100%', label: 'Spokojených zákazníků', icon: 'ri-star-line' },
    { number: '24/7', label: 'Havarijní služba', icon: 'ri-customer-service-2-line' },
  ];

  return (
    <>
      <Header />
      <main className="min-h-screen bg-gray-50">
        <h1 className="sr-only">Naše práce - Galerie realizací TopInstal Snajdr</h1>
        {/* Hero Section */}
        <section className="relative bg-gradient-to-br from-orange-500 via-orange-400 to-amber-400 py-20 overflow-hidden">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDM0YzAtMi4yMS0xLjc5LTQtNC00cy00IDEuNzktNCA0IDEuNzkgNCA0IDQgNC0xLjc5IDQtNHptMC0xMGMwLTIuMjEtMS43OS00LTQtNHMtNCAxLjc5LTQgNCAxLjc5IDQgNCA0IDQtMS43OSA0LTR6bTAtMTBjMC0yLjIxLTEuNzktNC00LTRzLTQgMS43OS00IDQgMS43OSA0IDQgNCA0LTEuNzkgNC00eiIvPjwvZz48L2c+PC9zdmc+')] opacity-30"></div>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <div className="text-center">
              <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 drop-shadow-lg">
                Ukázky naší práce
              </h2>
              <p className="text-xl md:text-2xl text-white/95 max-w-3xl mx-auto leading-relaxed drop-shadow">
                Podívejte se na ukázky našich profesionálních prací. Každý projekt realizujeme s maximálním důrazem na kvalitu, preciznost a spokojenost zákazníka.
              </p>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-12 bg-white border-b border-gray-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-3 gap-6 max-w-4xl mx-auto">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="inline-flex items-center justify-center w-12 h-12 bg-orange-100 rounded-full mb-3">
                    <i className={`${stat.icon} text-2xl text-orange-600`}></i>
                  </div>
                  <div className="text-3xl md:text-4xl font-bold text-gray-900 mb-1">{stat.number}</div>
                  <div className="text-sm md:text-base text-gray-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Category Filter */}
            <div className="mb-12">
              <div className="flex flex-wrap justify-center gap-3">
                {categories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => setActiveCategory(category.id)}
                    className={`inline-flex items-center px-6 py-3 rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                      activeCategory === category.id
                        ? 'bg-orange-500 text-white shadow-lg shadow-orange-500/30 scale-105'
                        : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200 hover:border-orange-300'
                    }`}
                  >
                    <i className={`${category.icon} mr-2 text-lg`}></i>
                    {category.name}
                  </button>
                ))}
              </div>
            </div>

            {/* Gallery Grid */}
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-3 sm:gap-6 mb-16">
              {filteredImages.map((image, index) => (
                <div
                  key={index}
                  className="group relative overflow-hidden rounded-lg sm:rounded-2xl shadow-md hover:shadow-2xl transition-all duration-500 cursor-pointer bg-white"
                  onClick={() => setSelectedImage(image.src)}
                >
                  <div className="aspect-[3/4] relative overflow-hidden">
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="w-10 h-10 sm:w-14 sm:h-14 bg-white rounded-full flex items-center justify-center shadow-xl transform group-hover:scale-110 transition-transform duration-300">
                        <i className="ri-zoom-in-line text-xl sm:text-2xl text-orange-500"></i>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA Section */}
            <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 p-12 shadow-2xl">
              <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDM0YzAtMi4yMS0xLjc5LTQtNC00cy00IDEuNzktNCA0IDEuNzkgNCA0IDQgNC0xLjc5IDQtNHptMC0xMGMwLTIuMjEtMS43OS00LTQtNHMtNCAxLjc5LTQgNCAxLjc5IDQgNCA0IDQtMS43OSA0LTR6bTAtMTBjMC0yLjIxLTEuNzktNC00LTRzLTQgMS43OS00IDQgMS43OSA0IDQgNCA0LTEuNzkgNC00eiIvPjwvZz48L2c+PC9zdmc+')] opacity-50"></div>
              <div className="relative z-10 text-center max-w-3xl mx-auto">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-500 rounded-full mb-6">
                  <i className="ri-tools-line text-3xl text-white"></i>
                </div>
                <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
                  Líbí se vám naše práce?
                </h3>
                <p className="text-lg text-gray-300 mb-8 leading-relaxed">
                  Rádi přijedeme i k vám. Zavolejte nám pro nezávaznou konzultaci nebo cenovou nabídku zdarma.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <a
                    href="tel:+420720520035"
                    className="inline-flex items-center justify-center px-8 py-4 bg-orange-500 text-white font-semibold rounded-xl hover:bg-orange-600 transition-all duration-300 shadow-lg shadow-orange-500/30 hover:shadow-xl hover:shadow-orange-500/40 hover:scale-105 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-phone-line mr-2 text-xl"></i>
                    720 520 035
                  </a>
                  <a
                    href="mailto:instatop.snajdr@post.cz"
                    className="inline-flex items-center justify-center px-8 py-4 bg-white text-gray-900 font-semibold rounded-xl hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-mail-line mr-2 text-xl"></i>
                    Napište nám
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Floating Call Button - Mobile Only */}
        <a
          href="tel:+420720520035"
          className="md:hidden fixed bottom-6 right-6 w-14 h-14 bg-orange-500 text-white rounded-full shadow-2xl flex items-center justify-center z-50 hover:bg-orange-600 transition-all duration-300 hover:scale-110 cursor-pointer"
          aria-label="Zavolat"
          style={{ animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite' }}
        >
          <i className="ri-phone-line text-2xl"></i>
        </a>

        {/* Image Modal */}
        {selectedImage && (
          <div
            className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4 backdrop-blur-sm"
            onClick={() => setSelectedImage(null)}
          >
            <button
              className="absolute top-6 right-6 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white transition-all duration-300 hover:scale-110 cursor-pointer z-10"
              onClick={() => setSelectedImage(null)}
            >
              <i className="ri-close-line text-3xl"></i>
            </button>
            <div className="relative max-w-6xl max-h-[90vh] animate-fadeIn">
              <img
                src={selectedImage}
                alt="Zvětšený náhled"
                className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          </div>
        )}
      </main>
      <Footer />
    </>
  );
}
